import { Link } from "react-router-dom";
import AxiosClient from "../../assets/AxiosClient";
import { useStateContext } from "../../Contexts/ContextProvider";
import { useEffect, useState } from "react";

const SponserRow = ({ id, name, description, logo, website, type, active, onDelete }) => {
  const { API } = useStateContext();

  const handleDeleteSponsor = () => {
    const confirmed = window.confirm("Are you sure you want to delete this sponsor?");
    if (confirmed) {
      onDelete(id);
    }
  };

  return (
    <tr>
      <td className="align-middle">{name}</td>
      <td className="align-middle">
        <img src={`${API}${logo}`} alt="Sponsor Logo" className="w-15" />
      </td>
      <td className="align-middle">{website}</td>
      <td className="align-middle">{type}</td>
      <td className="align-middle">{active ? "Active" : "Inactive"}</td>
      <td className="align-middle">
      
        <button className="btn btn-danger m-2" onClick={handleDeleteSponsor}>
          Delete Sponsor
        </button>
      </td>
    </tr>
  );
};

export default SponserRow;
